module.exports = __webpack_public_path__ + "static/media/all_students_icon.dec6316f.svg";